
















































import { defineComponent, PropType } from "@vue/composition-api";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import Pagination from "@/components/Atoms/Pagination/index.vue";
import OccSelectbox from "@/components/Atoms/OccSelectbox/index.vue";

export default defineComponent({
  components: {
    OccHeading,
    OccSelectbox,
    Pagination
  },
  emits: ["changeDisplayCount", "changePage"],
  props: {
    hitCount: {
      type: Number,
      default: undefined
    },

    selectableDisplayCount: {
      type: Boolean,
      default: true
    },
    displayCount: {
      type: Number,
      default: undefined
    },
    displayCountSelectList: {
      type: Array as PropType<{ value: string | number; label: string }[]>,
      default: () => [
        { value: 100, label: "100件" },
        { value: 200, label: "200件" },
        { value: 300, label: "300件" }
      ]
    },

    currentPage: {
      type: Number,
      required: true
    },
    totalPageCount: {
      type: Number,
      required: true
    },
    gaEventCategory: {
      type: String,
      default: undefined
    }
  }
});
